import { Box } from '@mantine/core'

import { useTranslation } from '@flecto/translations'

import { CardStoreDetails } from '../../components/CardStoreDetails/CardStoreDetails'
import { Page } from '../../components/Page/Page'
import { SectionContact } from '../../components/SectionContact/SectionContact'
import { useStoreDetails } from '../../hooks/useStoreDetails'
import styles from './styles.module.css'

export function PageTermsAndConditions() {
  const { t } = useTranslation('store', { keyPrefix: 'store-page-terms' })
  const store = useStoreDetails()

  return (
    <Page htmlTitle={t('html_title', { store: store?.name })}>
      <Page.Section title={t('title')}>
        <Box className={styles.pageTerms}>
          <Box
            mt='lg'
            dangerouslySetInnerHTML={{
              __html: store?.terms_and_conditions ?? '',
            }}
          />
          <CardStoreDetails h='max-content' />
        </Box>
      </Page.Section>
      <Page.Section withContainer={false}>
        <Box mb={-30}>
          <SectionContact />
        </Box>
      </Page.Section>
    </Page>
  )
}
